import { useState, useContext, createContext, ReactNode } from 'react';
import { UserInfo } from 'services/user';

type UserContextType = {
  user: UserInfo | null;
  setUser: (user: UserInfo | null) => void;
};

const UserContext = createContext<UserContextType>({
  user: null,
  setUser: () => null
});

/**
 * @return useContext use context user
 */
export function useUser(): UserContextType {
  return useContext(UserContext);
}

type Props = {
  children: ReactNode;
};

/**
 * @return UserProvider provider value user
 */
export function UserProvider({ children }: Props) {
  const [user, setUser] = useState<UserInfo | null>(null);
  const value = { user, setUser };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
}
